import UniversalCookies from 'universal-cookie';

/* eslint-disable @typescript-eslint/no-extraneous-class, @typescript-eslint/no-explicit-any */
class AppCookies {
  static readonly cookies = new UniversalCookies(null, { path: '/' });

  public static get(key: string) {
    return this.cookies.get(key);
  }

  public static set(key: string, value: any) {
    return this.cookies.set(key, JSON.stringify(value));
  }
}

export default AppCookies;
/* eslint-enable @typescript-eslint/no-extraneous-class, @typescript-eslint/no-explicit-any */
